import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c053584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bussiness-wrapper" }
const _hoisted_2 = { class: "bussiness-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"margin-top":"24px","padding-bottom":"24px"}
}
const _hoisted_4 = { class: "help-file-wrapper" }
const _hoisted_5 = { style: {"margin":"24px auto 20px"} }
const _hoisted_6 = {
  key: 0,
  class: "form-wrapper"
}
const _hoisted_7 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_8 = { style: {"width":"500px"} }
const _hoisted_9 = { style: {"color":"#333"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " (章程、股东会决议、登记申请书、授权委托) ", -1))
const _hoisted_11 = {
  key: 2,
  class: "flow-box"
}

import {
  ref,
  computed,
  watch,
  withDefaults,
  createVNode,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { USERLIST } from "../../../const/home";
import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import HelpText from "@/components/HelpText.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import { FileType, File, NodeItem } from "../../../types/procss";
import Image from "../../../components/Image.vue";
import Approval from "@/components/Approval.vue";

import Step1 from "./Detail/Step1.vue";
import Step2 from "./Detail/Step2.vue";
import Step3 from "./Detail/Step3.vue";
import type { FormInstance } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import {
  getBusinessApplyFirstInfo,
  startBusinessApplyFirst,
  getBusinessApplyThirdInfo,
  getBusinessFilingsInfo,
  startBusinessApplySecond,
  getBusinessApplySecondInfo,
  startBusinessApplyThird,
  startBusinessFilings,
} from "@/api/process_bussiness";
import { GetCurrentMyPageList } from "@/api/index";


export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const route = useRoute();
const { query } = route;
const id = ref(query.id || "");

const currentStep = ref<number>(0);
const activeKey = ref<string>("501");
const actionButtons = ref<(string | number)[]>([]); //默认是申请审批
const formRef0 = ref<FormInstance>(); //选址表单
const formRef1 = ref<FormInstance>(); //选址表单
const formRef2 = ref<FormInstance>(); //选址表单
const formRef3 = ref<FormInstance>(); //选址表单
const formRef4 = ref<FormInstance>(); //选址表单
const formRef5 = ref<FormInstance>(); //选址表单
const refresh = ref<boolean>(false);
const visible = ref<boolean>(false);
const visibleCompleted = ref<boolean>(false);
const isEditFile = ref<boolean>(false); //工商审批必传文件是否可编辑
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识

const WorkFlowId = ref<number>(0);
const firstIn = ref<boolean>(true);
const IsBackhaul = ref<boolean>(true); //必要文件可编辑
const edit = computed(() => actionButtons.value.includes("100"));

const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);
const IsFirstEdit = ref<boolean>(false); //是否第一次上传人力资源许可证扫描件或备案回执



watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      BranchCompanyFlowId.value = id;

      currentData.value = val.find((item: NodeItem) => item.Code == type);
      if (currentData.value.ChildAnchorPointCode) {
        currentData.value = val.find(
          (item: NodeItem) =>
            item.Code == currentData.value.ChildAnchorPointCode
        );
      }
      currentStep.value =
        currentData.value?.Code == "501" ||
        currentData.value?.Code == "502" ||
        currentData.value?.Code == "503"
          ? 0
          : 1;
      if (currentStep.value == 0) {
        activeKey.value = currentData.value?.Code;
      }
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "5");
      currentData.value = val.find(
        (item: NodeItem) => item.Code == _parent_data?.ChildAnchorPointCode
      );
      if (currentData.value) {
        if (firstIn.value) {
          //第一次进入
          currentStep.value =
            currentData.value?.Code == "501" ||
            currentData.value?.Code == "502" ||
            currentData.value?.Code == "503"
              ? 0
              : 1;
          if (currentStep.value == 0) {
            activeKey.value = currentData.value?.Code;
          }
        }
      }
    }
    firstIn.value = false;
    handleTabChange(currentStep.value);
  },
  {
    deep: true,
  }
);

watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});



let form = ref<{ PageFiles: File[] }>({
  PageFiles: [],
});

let form1 = ref({
  GsReviewBusRegisterName: "",
});

let form2 = ref<{ PageFiles: File[] }>({
  PageFiles: [],
});

let form3 = ref({
  GsDocumentCollection: [],
});

let form4 = ref({
  PageFiles: [],
});

form4.value.PageFiles = Array.from({ length: 6 }, () => {
  return {
    FileName: "",
    FileUrl: "",
    AccessoryType: "",
    Url: "",
  };
});

let form5 = ref({
  PageFiles: [],
});
let form6 = ref({
  PageFiles: [],
});
let PostFiles = ref({
  PageFiles: [],
});

const plainOptions = [
  "公章",
  "法人章",
  "合同章",
  "发票章",
  "财务章",
  "营业执照正本",
  "营业执照副本",
  "法人身份证",
  "股东身份证(Lisa)",
  "集团公司章程",
];

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 14 },
};

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "集团法务篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2023/202305/20230524/20230524_184419114791550_集团法务篇.pdf",
  },
];

const tableData = [
  {
    depart: "风控合规中心",
    name: "郑晓雪",
    duty: "房屋租赁合同审批、工商注册及备案审批",
    email: "xiaoxue.zheng@risfond.com",
    phone: "13911699671",
  },
];
const list = [
  "工商设立流程<br />① 提交复核工商注册名称 <br />② 提交工商设立需申请的表 <br />③ 提交印章、证照申请",
  "工商备案流程<br />提交工商注册相关资料",
];
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);
const IsSupplement = ref<boolean>(false); //

const handleUploadForm6 = (file: File) => {
  if (!file) {
    form6.value.PageFiles = [];
  } else {
    let _file = Object.assign({}, file, { FileUrl: file.Url });
    if (!form6.value.PageFiles[0] || !form6.value.PageFiles[0].FileUrl) {
      IsFirstEdit.value = true; //是否第一次提交
    }
    form6.value.PageFiles[0] = _file;
  }
};
//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    if (currentStep.value == 0) {
      if (visibleCompleted.value) {
        form5.value.PageFiles[index as number] = [];
      } else if (activeKey.value == "501") {
        form.value.PageFiles = [];
      } else if (activeKey.value == "502") {
        form2.value.PageFiles[index as number] = [];
      }
    } else {
      form4.value.PageFiles[index as number] = {
        FileName: "",
        FileUrl: "",
        AccessoryType: "",
        Url: "",
      };
    }
  } else {
    if (currentStep.value == 0) {
      if (visibleCompleted.value) {
        let _file = Object.assign({}, file, { FileUrl: file.Url });
        form5.value.PageFiles[index as number] = _file;
      } else if (activeKey.value == "501") {
        let _file = Object.assign({}, file, { FileUrl: file.Url });
        form.value.PageFiles = [_file];
      } else if (activeKey.value == "502") {
        let _file = Object.assign({}, file, { FileUrl: file.Url });
        form2.value.PageFiles[index as number] = _file;
      }
    } else {
      let _file = Object.assign({}, file, { FileUrl: file.Url });
      form4.value.PageFiles[index as number] = _file;
    }
  }
};

const handleTabChange = async (index: number) => {
  reEdit.value = false;
  if (index == 1) {
    BranchCompanyFlowId.value = filterCompanyCode("504");
    BusinessFilingsInfo();
  } else {
    handleActiveTabChange();
  }
};

const handleActiveTabChange = () => {
  reEdit.value = false;
  BranchCompanyFlowId.value = filterCompanyCode(activeKey.value);
  if (activeKey.value == "501") {
    BusinessApplyFirstInfo();
  } else if (activeKey.value == "502") {
    BusinessApplySecondInfo();
  } else if (activeKey.value == "503") {
    BusinessApplyThirdInfo();
  }
};

const filterCompanyCode = (code: string) => {
  WorkFlowId.value = -1;
  const { id, type } = route.query;
  const item_data = props.flowData.find((item) => item.Code == code);
  if (!item_data) {
    preData.value = {
      Title: "开业申请",
      PreConditionCode: "0",
      BranchCompanyFlowId: 0,
    };
  } else {
    currentData.value = props.flowData.find(
      (item: NodeItem) => item.Code == code
    );
    IsBackhaul.value = currentData.value.IsBackhaul;
    if (!item_data.IsOperation) {
      if (code == "504") {
        preData.value = {
          Title: "工商设立申请",
        };
      } else {
        preData.value = props.flowData.find(
          (_item: NodeItem) => _item.Code == item_data?.PreConditionCode
        );
        if (currentData.value?.IsOperation) {
          //前置节点已完成
          preData.value = null;
        }
      }
    } else {
      preData.value = null;
    }
  }
  if (!type) {
    return item_data?.BranchCompanyFlowId || 0;
  } else if (code == type) {
    return id || item_data?.BranchCompanyFlowId || 0;
  } else if (code != type) {
    return item_data?.BranchCompanyFlowId || 0;
  }
};

const BusinessApplyFirstInfo = async () => {
  const { Data } = await getBusinessApplyFirstInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId || 0;

  if (Data?.PageData) {
    form1.value = Data?.PageData;
  }
  if (Data?.PageFiles && Data?.PageFiles.length > 0) {
    form.value = { PageFiles: Data?.PageFiles || [] };
  }
};
const BusinessApplySecondInfo = async () => {
  const { Data } = await getBusinessApplySecondInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  actionButtons.value = Data?.ActionButtons || [];
  if (Data?.PageFiles?.length > 0) {
    form2.value = { PageFiles: Data?.PageFiles || [] };
  }
  PostFiles.value = { PageFiles: Data?.PostFiles || [] };

  WorkFlowId.value = Data?.WorkFlowId || 0;
};
const BusinessApplyThirdInfo = async () => {
  const { Data } = await getBusinessApplyThirdInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  actionButtons.value = Data?.ActionButtons || [];
  if (Data?.PageData) {
    form3.value.GsDocumentCollection =
      Data?.PageData.GsDocumentCollection.split(",");
  }
  WorkFlowId.value = Data?.WorkFlowId || 0;
};

const BusinessFilingsInfo = async () => {
  const { Data } = await getBusinessFilingsInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  actionButtons.value = Data?.ActionButtons || [];
  isEditFile.value = Data.IsEdit;

  if (Data?.PageFiles?.length > 0) {
    form4.value.PageFiles = Data?.PageFiles.filter(
      (item) => item.AccessoryType != 544
    );
    form6.value.PageFiles = Data?.PageFiles.filter(
      (item) => item.AccessoryType == 544
    );
  }
  WorkFlowId.value = Data?.WorkFlowId || 0;
};

const submit1 = async () => {
  formRef1.value?.validateFields().then(async (res) => {
    formRef0.value?.validateFields().then(async (res) => {
      //提交申请
      const { Success, Message } = await startBusinessApplyFirst({
        BranchCompanyFlowId: BranchCompanyFlowId.value,
        PageData: {
          BranchCompanyFlowId: BranchCompanyFlowId.value,
          GsReviewBusRegisterName: form1.value.GsReviewBusRegisterName,
        },
        PageFiles: form.value.PageFiles || [],
      });
      if (Success) {
        message.success("已提交审核");
        $emit("update-flow");
        reEdit.value = false;
      } else {
        message.error(Message || "提交失败，请稍后重试");
      }
    });
  });
};
const submit2 = async () => {
  //提交申请
  formRef2.value?.validateFields().then(async (res) => {
    const { Success, Message } = await startBusinessApplySecond({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageFiles: form2.value.PageFiles || [],
      IsSupplement: false,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
const submit3 = async () => {
  formRef3.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await startBusinessApplyThird({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageData: {
        GsDocumentCollection: form3.value.GsDocumentCollection.join(","),
      },
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
const submit4 = () => {
  formRef4.value?.validateFields().then(async (res) => {
    let _file = form4.value.PageFiles;
    //提交申请
    if (form6.value.PageFiles.length > 0) {
      _file = [..._file, ...form6.value.PageFiles];
    }
    const { Success, Message } = await startBusinessFilings({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageFiles: _file,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
const handleReSubmit = () => {
  if (currentStep.value == 0) {
    if (activeKey.value == "501") {
      submit1();
    } else if (activeKey.value == "502") {
      submit2();
    } else if (activeKey.value == "503") {
      submit3();
    }
  } else {
    submit4();
  }
};

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    handleReSubmit();
    IsFirstEdit.value = false;
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "101") {
    visible.value = true;
  } else if (buttonType == "303") {
    //补充资料
    visibleCompleted.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    //通过
    applyOnOkVisible.value = true;
  } else if (buttonType == "-1") {
    reEdit.value = false;
    handleTabChange(currentStep.value);
    //节点
  } else if (buttonType == "-2") {
    IsFirstEdit.value = false;
    handleReSubmit();
  }
};
//补充资料
const submitComplete = () => {
  formRef5.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await startBusinessApplySecond({
      BranchCompanyFlowId: 0, //提交补充资料相当于每次都是新申请
      PageFiles: [...form5.value.PageFiles, ...form2.value.PageFiles],
      IsSupplement: true,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      handleCancelComplete();
      IsSupplement.value = true;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};
const handleCancelComplete = () => {
  visibleCompleted.value = false;
  form5.value.PageFiles = [];
};

const handleCallback = (update: boolean) => {
  visible.value = !visible.value;
  if (update) {
    $emit("update-flow");
  }
  refresh.value = !refresh.value;
  getList();
};

const handleRejectback = () => {
  rejectedVisible.value = false;
  $emit("update-flow");
  refresh.value = !refresh.value;
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_RecallBack = _resolveComponent("RecallBack")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "工商设立及备案" }),
        _createVNode(HelpText, {
          class: "border-bottom",
          list: list,
          width: 248,
          height: 130
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "工商设立及备案注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
              return _createVNode(HelpFile, {
                key: index,
                title: item.title,
                "file-path": item.link,
                "file-type": item.type
              }, null, 8, ["title", "file-path", "file-type"])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_steps, {
                  class: "bussiness-step",
                  current: currentStep.value,
                  "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((currentStep).value = $event)),
                  size: "small",
                  onChange: handleTabChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_step, {
                      title: "工商设立申请",
                      status: currentStep.value == 0 ? 'process' : 'wait'
                    }, null, 8, ["status"]),
                    _createVNode(_component_a_step, {
                      title: "工商备案",
                      status: currentStep.value == 1 ? 'process' : 'wait'
                    }, null, 8, ["status"])
                  ]),
                  _: 1
                }, 8, ["current"])
              ]),
              _createElementVNode("div", {
                class: "content-wrapper",
                style: _normalizeStyle([{"padding-bottom":"20px"}, currentStep.value == 0 ? { marginTop: '12px' } : {}])
              }, [
                (currentStep.value == 0)
                  ? (_openBlock(), _createBlock(_component_a_tabs, {
                      key: 0,
                      activeKey: activeKey.value,
                      "onUpdate:activeKey": _cache[6] || (_cache[6] = ($event: any) => ((activeKey).value = $event)),
                      onChange: handleActiveTabChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "501",
                          tab: "申请事项一"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(
                    currentData.value && currentData.value.State > 1 && !reEdit.value
                      ? 'border-bottom'
                      : ''
                  )
                            }, [
                              (
                      (id.value &&
                        _unref(personInfo).IsCreate == 0 &&
                        !_unref(form1).GsReviewBusRegisterName) ||
                      WorkFlowId.value == 0 ||
                      reEdit.value
                    )
                                ? (_openBlock(), _createBlock(_component_a_form, {
                                    key: 0,
                                    class: "bussiness-form-wrapper",
                                    validateTrigger: "blur",
                                    model: _unref(form1),
                                    ref_key: "formRef1",
                                    ref: formRef1
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        name: "GsReviewBusRegisterName",
                                        label: "复核工商注册名称",
                                        required: "",
                                        colon: false,
                                        rules: [
                        {
                          max: 50,
                        },
                      ]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input, {
                                            value: _unref(form1).GsReviewBusRegisterName,
                                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form1).GsReviewBusRegisterName) = $event)),
                                            placeholder: "请输入",
                                            style: {"width":"300px"}
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model"]))
                                : _createCommentVNode("", true),
                              (WorkFlowId.value == 0 || reEdit.value)
                                ? (_openBlock(), _createBlock(_component_a_form, {
                                    key: 1,
                                    class: "bussiness-form-wrapper",
                                    layout: "vertical",
                                    validateTrigger: "blur",
                                    model: _unref(form),
                                    ref_key: "formRef0",
                                    ref: formRef0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        name: ['PageFiles', 0, 'FileUrl'],
                                        label: "分子公司工商设立/变更申请表",
                                        required: "",
                                        rules: [
                        {
                          required: true,
                          message: '请添加分子公司工商设立/变更申请表',
                        },
                      ]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Image, {
                                            value: 
                          _unref(form).PageFiles && _unref(form).PageFiles.length > 0
                            ? _unref(form).PageFiles[0].FileUrl
                            : ''
                        ,
                                            "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                            disable: !!preData.value,
                                            onUpload: _cache[2] || (_cache[2] = (file) => handleUpload(file, 0)),
                                            "download-link": {
                          filename: '分子公司工商设立/变更申请表.docx',
                          fileKey: '5011',
                        },
                                            "file-type": '511'
                                          }, null, 8, ["value", "disable-close", "disable", "download-link"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model"]))
                                : (activeKey.value == '501')
                                  ? (_openBlock(), _createBlock(Step1, {
                                      key: 2,
                                      detail: {
                      PageData: _unref(form1),
                      PageFiles: _unref(form).PageFiles,
                    }
                                    }, null, 8, ["detail"]))
                                  : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "502",
                          tab: "申请事项二",
                          "force-render": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(
                    currentData.value && currentData.value.State > 1 && !reEdit.value
                      ? 'border-bottom'
                      : ''
                  )
                            }, [
                              _createVNode(_component_a_form, {
                                class: "bussiness-form-wrapper",
                                layout: "vertical",
                                model: _unref(form2),
                                ref_key: "formRef2",
                                ref: formRef2
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    name: ['PageFiles', 0, 'FileUrl'],
                                    label: "资料提供申请表",
                                    required: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(Image, {
                                        value: 
                          _unref(form2).PageFiles && _unref(form2).PageFiles.length > 0
                            ? _unref(form2).PageFiles[0].FileUrl
                            : ''
                        ,
                                        "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                        disable: !!preData.value,
                                        onUpload: _cache[3] || (_cache[3] = (file) => handleUpload(file, 0)),
                                        "download-link": {
                          filename: '资料提供申请表.docx',
                          fileKey: '5021',
                        },
                                        "file-type": '521'
                                      }, null, 8, ["value", "disable-close", "disable", "download-link"])
                                    ]),
                                    _: 1
                                  }),
                                  (
                        _unref(PostFiles).PageFiles.length > 0 && _unref(PostFiles).PageFiles[0]
                      )
                                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                                        key: 0,
                                        style: {"margin-right":"60px"},
                                        name: "PostFiles",
                                        label: "资料提供申请表补充",
                                        required: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Image, {
                                            value: 
                          _unref(PostFiles).PageFiles && _unref(PostFiles).PageFiles.length > 0
                            ? _unref(PostFiles).PageFiles[0].FileUrl
                            : ''
                        ,
                                            "disable-close": true,
                                            disable: true,
                                            "file-type": '5211'
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_a_form_item, {
                                    name: ['PageFiles', 1, 'FileUrl'],
                                    label: "用印、用证审批表",
                                    required: "",
                                    rules: [
                        { required: true, message: '请上传用印、用证审批表' },
                      ]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(Image, {
                                        value: 
                          _unref(form2).PageFiles && _unref(form2).PageFiles.length > 1
                            ? _unref(form2).PageFiles[1].FileUrl
                            : ''
                        ,
                                        "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                        disable: !!preData.value,
                                        onUpload: _cache[4] || (_cache[4] = (file) => handleUpload(file, 1)),
                                        "download-link": {
                          filename: '用印、用证审批表.docx',
                          fileKey: '5022',
                        },
                                        "file-type": '522'
                                      }, null, 8, ["value", "disable-close", "disable", "download-link"])
                                    ]),
                                    _: 1
                                  }),
                                  (
                        _unref(PostFiles).PageFiles.length > 1 && _unref(PostFiles).PageFiles[1]
                      )
                                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                                        key: 1,
                                        name: ['PageFiles', 1, 'FileUrl'],
                                        label: "用印、用证审批表补充",
                                        required: "",
                                        rules: [
                        { required: true, message: '请上传用印、用证审批表' },
                      ]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Image, {
                                            value: 
                          _unref(PostFiles).PageFiles && _unref(PostFiles).PageFiles.length > 1
                            ? _unref(PostFiles).PageFiles[1].FileUrl
                            : ''
                        ,
                                            "disable-close": true,
                                            disable: true,
                                            "file-type": '5221'
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ], 2)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "503",
                          tab: "申请事项三"
                        }, {
                          default: _withCtx(() => [
                            (
                    (id.value &&
                      _unref(personInfo).IsCreate == 0 &&
                      _unref(form3).GsDocumentCollection.length == 0) ||
                    WorkFlowId.value == 0 ||
                    reEdit.value
                  )
                              ? (_openBlock(), _createBlock(_component_a_form, {
                                  key: 0,
                                  class: _normalizeClass(["bussiness-check-wrapper", 
                    currentData.value && currentData.value.State > 1 && !reEdit.value
                      ? 'border-bottom'
                      : ''
                  ]),
                                  layout: "vertical",
                                  validateTrigger: "blur",
                                  model: _unref(form3),
                                  ref_key: "formRef3",
                                  ref: formRef3
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      name: "GsDocumentCollection",
                                      label: "印章、证照刻制申请（请勾选）",
                                      required: "",
                                      style: {"margin-bottom":"14px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_checkbox_group, {
                                          value: _unref(form3).GsDocumentCollection,
                                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form3).GsDocumentCollection) = $event))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { wrap: true }, {
                                              default: _withCtx(() => [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(plainOptions, (item, index) => {
                                                  return _createVNode(_component_a_col, {
                                                    span: 4,
                                                    key: index,
                                                    style: {"margin-bottom":"10px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_checkbox, {
                                                        value: (index + 1).toString(),
                                                        label: item
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", _hoisted_9, _toDisplayString(plainOptions[index]), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["value", "label"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                }), 64))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class", "model"]))
                              : (_openBlock(), _createBlock(Step3, {
                                  key: 1,
                                  class: "border-bottom",
                                  "flow-id": BranchCompanyFlowId.value,
                                  detail: {
                    PageData: _unref(form3),
                  }
                                }, null, 8, ["flow-id", "detail"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["activeKey"]))
                  : (_openBlock(), _createBlock(_component_a_form, _mergeProps({
                      key: 1,
                      layout: "vertical",
                      ref_key: "formRef4",
                      ref: formRef4,
                      model: _unref(form4)
                    }, formItemLayout, {
                      validateTrigger: "blur",
                      style: {"padding-bottom":"20px"},
                      class: ["form-upload form4-upload", 
                currentData.value && currentData.value.State > 1 && !reEdit.value
                  ? 'border-bottom'
                  : ''
              ]
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              name: ['PageFiles', 0, 'FileUrl'],
                              label: "工商营业执照正本",
                              required: "",
                              class: "form-upload-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 0
                        ? _unref(form4).PageFiles[0].FileUrl
                        : ''
                    ,
                                  "disable-close": 
                      !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value))
                    ,
                                  disable: !!preData.value,
                                  onUpload: _cache[7] || (_cache[7] = (file) => handleUpload(file, 0)),
                                  "file-type": '541'
                                }, null, 8, ["value", "disable-close", "disable"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              name: ['PageFiles', 1, 'FileUrl'],
                              label: "工商营业执照副本",
                              required: "",
                              class: "form-upload-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 1
                        ? _unref(form4).PageFiles[1].FileUrl
                        : ''
                    ,
                                  "disable-close": 
                      !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value))
                    ,
                                  disable: !!preData.value,
                                  onUpload: _cache[8] || (_cache[8] = (file) => handleUpload(file, 1)),
                                  "file-type": '542'
                                }, null, 8, ["value", "disable-close", "disable"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              name: ['PageFiles', 2, 'FileUrl'],
                              label: "负责人身份证复印件（无遮挡无水印）",
                              class: "form-upload-item",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 2
                        ? _unref(form4).PageFiles[2].FileUrl
                        : ''
                    ,
                                  "disable-close": 
                      !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value))
                    ,
                                  disable: !!preData.value,
                                  onUpload: _cache[9] || (_cache[9] = (file) => handleUpload(file, 2)),
                                  "file-type": '543'
                                }, null, 8, ["value", "disable-close", "disable"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              name: "form6",
                              label: "人力资源许可证扫描件或备案回执",
                              class: "form-upload-item"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form6).PageFiles && _unref(form6).PageFiles.length > 0
                        ? _unref(form6).PageFiles[0].FileUrl
                        : ''
                    ,
                                  "disable-close": !(WorkFlowId.value == 0 || IsFirstEdit.value || reEdit.value),
                                  disable: !(!preData.value && (reEdit.value || _unref(edit))),
                                  onUpload: _cache[10] || (_cache[10] = (file) => handleUploadForm6(file)),
                                  "file-type": '544'
                                }, null, 8, ["value", "disable-close", "disable"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              name: ['PageFiles', 3, 'FileUrl'],
                              label: "开业至今工商调档材料",
                              class: "form-upload-item form-tips",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 3
                        ? _unref(form4).PageFiles[3].FileUrl
                        : ''
                    ,
                                  "disable-close": 
                      !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value))
                    ,
                                  disable: !!preData.value,
                                  onUpload: _cache[11] || (_cache[11] = (file) => handleUpload(file, 3)),
                                  "file-type": '545'
                                }, null, 8, ["value", "disable-close", "disable"]),
                                _hoisted_10
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              name: ['PageFiles', 4, 'FileUrl'],
                              label: "印鉴留存卡",
                              class: "form-upload-item",
                              required: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 4
                        ? _unref(form4).PageFiles[4].FileUrl
                        : ''
                    ,
                                  "disable-close": 
                      !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value))
                    ,
                                  disable: !!preData.value,
                                  onUpload: _cache[12] || (_cache[12] = (file) => handleUpload(file, 4)),
                                  "file-type": '546'
                                }, null, 8, ["value", "disable-close", "disable"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_form_item, {
                              name: ['PageFiles', 5, 'FileUrl'],
                              label: "印章、证照保管承诺书",
                              class: "form-upload-item",
                              required: "",
                              style: {"margin-right":"130px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 5
                        ? _unref(form4).PageFiles[5].FileUrl
                        : ''
                    ,
                                  "disable-close": 
                      !(WorkFlowId.value == 0 || (isEditFile.value && reEdit.value))
                    ,
                                  disable: !!preData.value,
                                  onUpload: _cache[13] || (_cache[13] = (file) => handleUpload(file, 5)),
                                  "file-type": '547',
                                  "download-link": {
                      filename: '印章、证照保管承诺书.docx',
                      fileKey: '5041',
                    }
                                }, null, 8, ["value", "disable-close", "disable", "download-link"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16, ["model", "class"])),
                _createVNode(_component_a_modal, {
                  class: "modal-dialog",
                  bodyStyle: {
              width: '460px',
              height: '216px',
            },
                  visible: visibleCompleted.value,
                  "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((visibleCompleted).value = $event)),
                  title: "申请事项二补充申请",
                  onOk: submitComplete,
                  onCancel: handleCancelComplete
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form, {
                      class: "bussiness-form-complete",
                      layout: "vertical",
                      model: _unref(form5),
                      ref_key: "formRef5",
                      ref: formRef5
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          style: {"margin-right":"60px"},
                          name: ['PageFiles', 0, 'FileUrl'],
                          label: "资料提供申请表",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                    _unref(form5).PageFiles && _unref(form5).PageFiles.length > 0
                      ? _unref(form5).PageFiles[0].FileUrl
                      : ''
                  ,
                              "disable-close": false,
                              disable: false,
                              onUpload: _cache[14] || (_cache[14] = (file) => handleUpload(file, 0)),
                              "file-type": 5211
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          name: ['PageFiles', 1, 'FileUrl'],
                          label: "用印、用证审批表",
                          required: "",
                          rules: [{ required: true, message: '请上传用印、用证审批表' }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Image, {
                              value: 
                    _unref(form5).PageFiles && _unref(form5).PageFiles.length > 1
                      ? _unref(form5).PageFiles[1].FileUrl
                      : ''
                  ,
                              "disable-close": false,
                              disable: false,
                              onUpload: _cache[15] || (_cache[15] = (file) => handleUpload(file, 1)),
                              "file-type": 5221
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(_component_RecallBack, {
                  id: BranchCompanyFlowId.value,
                  show: visible.value,
                  onClose: handleCallback
                }, null, 8, ["id", "show"]),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, {
                        refresh: refresh.value,
                        id: WorkFlowId.value
                      }, null, 8, ["refresh", "id"])
                    ]))
                  : _createCommentVNode("", true)
              ], 4)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (actionButtons.value.length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": actionButtons.value,
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成${preData.value.Title}审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"])
  ], 64))
}
}

})